import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
export function EndNote() {
  return <section className="border-t border-line" data-id="element-33" data-mp="2xwdozrkgpqhm">
      <div className="mx-auto flex max-w-page flex-wrap items-end justify-between gap-6 px-6 py-12 md:px-10 md:py-16" data-id="element-34" data-mp="32wrtx0qrokbf">
        <Link to="/contact" className="group inline-flex items-center gap-3 font-display text-3xl font-bold uppercase leading-none transition-colors hover:text-lilac md:text-5xl" data-id="element-35" data-mp="36yv65rl9fsxr">
          Start a project
          <ArrowUpRightIcon size={26} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" data-id="element-36" data-mp="2f7p2j16bzd3q" />
        </Link>
        <a href="mailto:info@heybreezy.co" className="text-[0.65rem] uppercase tracking-micro text-muted transition-colors hover:text-lilac" data-id="element-37" data-mp="2o0amgklp7pu5">
          info@heybreezy.co
        </a>
      </div>
    </section>;
}